import isEqual from 'lodash/isEqual'
import { getInvoiceList as getInvoiceListApi, eidtInvoiceStatus } from '@/api/invoice-v2'

function getOrderBy(property) {
  let orderBy = ''
  switch(property) {
    case 'createAt':
      orderBy = 'create_at'
      break
    case 'invoiceDate':
      orderBy = 'invoice_date'
      break
    case 'payDate':
      orderBy = 'pay_date'
      break
    default:
      orderBy = property
  }
  return orderBy || ''
}

function formatInvoice(info) {
  if (info.status) {
    let value = ''
    switch (info.status) {
      case 'draft':
      case 'Draft':
        value = '8'
        break
      case 'sent':
      case 'Sent':
        value = '0'
        break
      case 'paid':
      case 'Paid':
        value = '9'
        break
    }
    info.statusConverter = {
      value: value,
      label: info.status,
    }
  }
  return info
}

const store = {
  namespaced: true,
  state: {
    invoiceList: [],
    currentPage: 1,
    pageSize: 20,
    total: 0,
    searchForm: {
      search: '',
      status: [],
      customer: [],
      ownerId: [],
      payDate: [],
      overdueFilterEnums: []
    },
    sortInfo: {
      order: '',
      property: ''
    },
    lastListParams: {}
  },
  mutations: {
    SET_INVOICE_LIST(state, list) {
      state.invoiceList = list
    },
    SET_CURRENT_PAGE(state, currentPage) {
      state.currentPage = currentPage
    },
    SET_PAGE_SIZE(state, pageSize) {
      state.pageSize = pageSize
    },
    SET_TOTAL(state, total) {
      state.total = total
    },
    SET_SEARCH_FORM(state, searchForm) {
      state.searchForm = searchForm
    },
    SET_SORT_INFO(state, sortInfo) {
      state.sortInfo = sortInfo
    },
    SET_LAST_PARAMS(state, params) {
      state.lastListParams = params
    }
  },
  getters: {
    _getParams(state) {
      return {
        current: state.currentPage,
        size: state.pageSize,
        customer: state.searchForm.customer,
        invoiceId: state.searchForm.search,
        status: state.searchForm.status,
        ownerId: state.searchForm.ownerId,
        orderBy: getOrderBy(state.sortInfo.property),
        sort: state.sortInfo.order ? state.sortInfo.order.toUpperCase() : '',
        time: state.searchForm.time,
        startPayDate: state.searchForm.payDate ? state.searchForm?.payDate[0] : '', 
        endPayDate : state.searchForm.payDate ? state.searchForm.payDate[1] : '',
        overdueFilterEnums: state.searchForm?.overdueFilterEnums
      }
    },
  },
  actions: {
    _getList({ getters, commit, state }) {
      let params = getters._getParams
      params.timezone= Intl.DateTimeFormat().resolvedOptions().timeZone
      if (isEqual(params, state.lastListParams) && state.invoiceList.length) return Promise.resolve(state.invoiceList)
      commit('SET_LAST_PARAMS', params)
      return getInvoiceListApi(params).then(result => {
        if (!isEqual(getters._getParams, params)) return null
        commit('SET_TOTAL', result.data.total)
        commit('SET_INVOICE_LIST', result.data.data.map(item => formatInvoice(item)))
      })
    },
    getInvoiceList({ dispatch, state }, refresh) {
      if (state.invoiceList.length && !refresh) {
        return Promise.resolve(state.invoiceList)
      }
      return dispatch('_getList')
    },
    editStatus({ state, commit }, data) {
      return eidtInvoiceStatus(data).then(result => {
        let list = state.invoiceList.map(item => item.id === result.data.id ? formatInvoice(result.data) : item)
        commit('SET_INVOICE_LIST', list)
      })
    },
    updateLastParams({ commit }, params) {
      commit('SET_LAST_PARAMS', params)
    },
    updateInvoiceList({ commit }, list) {
      commit('SET_INVOICE_LIST', list)
    },
    updateSearchForm({ commit }, searchForm) {
      console.log(searchForm,'128');
      commit('SET_SEARCH_FORM', Object.assign({}, searchForm))
    },
    updateSortInfo({ commit }, sortInfo) {
      commit('SET_SORT_INFO', { order: sortInfo.order, property: sortInfo.property })
    },
    updateCurrentPage({ commit }, currentPage) {
      commit('SET_CURRENT_PAGE', currentPage)
    },
    updatePageSize({ commit }, pageSize) {
      commit('SET_PAGE_SIZE', pageSize)
    },
    updateTotal({ commit }, total) {
      commit('SET_TOTAL', total)
    }
  }
}

export default store